module.exports = __webpack_public_path__ + "static/img/adcode.4401da2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/adcode.png
// module id = 6Vgj
// module chunks = 13